import { differenceInMonths, differenceInYears } from "date-fns";

export const dateYearsMonths = (date: Date, today = new Date()) => {
  const years = differenceInYears(today, date);
  let output = "";
  let suffix = "";

  if (years < 3) {
    // output only months
    output += differenceInMonths(today, date);
    suffix = "m";
  } else {
    // output only years
    output += years;
  }

  if (Number.isNaN(Number(output))) {
    return "";
  }
  return `${output}${suffix}`;
};

export const removeTypename = (raw) => {
  const result = Object.keys(raw)
    .filter((key) => !["__typename"].includes(key))
    .reduce((object, key) => {
      object[key] = raw[key];
      return object;
    }, {});

  return result;
};
